import PaymentManagementDashboard from "./PaymentManagementDashboard"

export default  PaymentManagementDashboard;



// WEBPACK FOOTER //
// ./src/components/App/PaymentManagementDashboard/index.js